import React from 'react';
import { useMotionValue, useTransform } from 'framer-motion';
import { motion } from "../../Motion-polyfill";
import { Description, renderLineBreak, SubTitle } from '../../components/layouts';
import Sequence from '../../components/sequence';
import { SeqencePlaceholder } from '../../components/sequence/Placeholder';
import Visibility from '../../components/Visibility';
import { AppContext } from '../../Context';
import { getSeqFrames, getTrack, pureTrans } from '../../helpers';
import './style.scss';

const track = getTrack({ block: 20 });

const FRAME_LENGTH = 92;

export function Gaming({ mobile = false }) {
  const [framesLoaded, setFramesLoaded] = React.useState(false);
  const [frozen, freeze] = React.useState(true);
  const [index, setIndex] = React.useState(-1);
  const progress = useMotionValue(0);
  const handleUpdate = React.useCallback(
    (e, { calculations }) => {
      const { percentagePassed, pixelsPassed, height, offScreen } = calculations;
      freeze(offScreen || pixelsPassed <= -1000 || pixelsPassed >= height + 1000);
      progress.set(percentagePassed);
      const i = pureTrans(percentagePassed, [0.2, 0.8], [0, FRAME_LENGTH - 1], 0);
      setIndex(i);
    },
    [progress, freeze, setIndex]
  );

  const { webpSupport, webpDetectionFinished } = React.useContext(AppContext);

  const frames = React.useMemo(() => {
    return getSeqFrames({
      prefix: 'gaming',
      mobile: false,
      webpSupport: false,
      len: FRAME_LENGTH
    });
  }, [webpSupport]);

  const ot = useTransform(progress, [-0.1, 0.2], [1, 1]);
  const yt = useTransform(progress, [-0.1, 0.2, 0.4], [0, 0, 0]);

  const onFramesLoaded = React.useCallback(() => {
    setFramesLoaded(true);
  }, [setFramesLoaded]);

  const seqReady = !frozen && webpDetectionFinished;

  return (
    <Visibility
      fireOnMount
      offset={[-1000, 1000]}
      onUpdate={handleUpdate}
      className="page-section section-gaming inverted"
      data-track={track}
    >
      <div className="sticky-content">
        <div className="section-content center">
          <motion.div style={{ opacity: ot, y: yt }}>
            <SubTitle>游戏电竞{renderLineBreak(mobile)}够爽才够 battle</SubTitle>
            <Description>
              游戏画面高清流畅，鹰眼模式2.0与游戏护眼2.0，保障优质的游戏体验的同时，即便长时间游戏，仍有效缓解眼睛的疲劳程度。
            </Description>
          </motion.div>
        </div>
        <div className="section-background">
          <div className="sequence-wrapper">
            <Sequence name="gaming" current={index} frames={frames} active={seqReady} onload={onFramesLoaded} />
            <SeqencePlaceholder src={frames[frames.length - 1]} visible={!seqReady || !framesLoaded} />
          </div>
        </div>
      </div>
    </Visibility>
  );
}
